import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  ${props =>
    props.cancelled &&
    css`
      text-decoration: line-through;
      opacity: 0.6;
    `}
`

export const ProductImage = styled.img`
  height: 108px;
  width: 108px;
  border-radius: ${props => props.theme.primitives.radius.radius2};
`
